import { render } from "./DashboardIcon.vue?vue&type=template&id=b42a182e&scoped=true"
import script from "./DashboardIcon.vue?vue&type=script&lang=js"
export * from "./DashboardIcon.vue?vue&type=script&lang=js"

import "./DashboardIcon.vue?vue&type=style&index=0&id=b42a182e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42a182e"]])

export default __exports__